import React from 'react';
import { Avatar } from 'antd';
import PropTypes from 'prop-types';

const NotificationItem = ({ notification }) => {
  const {
    icon, image, title, time
  } = notification;
  return (

    <li className="gx-media">
      <Avatar
        alt={image}
        className="gx-size-40 gx-mr-3"
        src={image}
      />
      <div className="gx-media-body gx-align-self-center">
        <p className="gx-fs-sm gx-mb-0">{title}</p>
        <i className={`icon icon-${icon} gx-pr-2`} /> <span className="gx-meta-date"><small>{time}</small></span>
      </div>
    </li>
  );
};

NotificationItem.propTypes = {
  notification: PropTypes.objectOf(PropTypes.any).isRequired
};

export default NotificationItem;
